const LicenseCategoryReport = () =>
  import(
    /* webpackChunkName: "base-info-courier-license-category" */ '@/pages/base-info/courier/license-category/index.vue'
  )
const CreateCourierLicenseCategory = () =>
  import(
    /* webpackChunkName: "base-info-courier-license-category" */ '@/pages/base-info/courier/license-category/create.vue'
  )
const EditCourierLicenseCategory = () =>
  import(
    /* webpackChunkName: "base-info-courier-license-category" */ '@/pages/base-info/courier/license-category/edit.vue'
  )

export default {
  path: 'license-category',
  meta: {
    label: 'courierLicenseCategory',
    auth: 'licenseCategory'
  },
  component: {
    name: 'LicenseCategory',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCourierLicenseCategory',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: LicenseCategoryReport
    },
    {
      name: 'BaseInfoCreateCourierLicenseCategory',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCourierLicenseCategory
    },
    {
      name: 'BaseInfoEditCourierLicenseCategory',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCourierLicenseCategory,
      props: true
    }
  ]
}
